export default {
  Profile: {
    Home: {
      update_success: 'Usuario actualizado exitosamente',
    },
    Header: {
      subtitle: 'configuración de usuario',
      title: 'Perfil',
    },
  },
}
